/**
 * soj的相关配置
 */
module.exports = {
  devLogURL: '//s.anjuke.test/ts.html?',
  logURL: '//prism.anjuke.com/ts.html?',
  devSojURL: '//s.anjuke.test/stb',
};
